export const updateLocalStorageItem = (
  key: string,
  value: string | undefined
) => {
  if (value) {
    localStorage.setItem(key, value);
  } else {
    localStorage.removeItem(key);
  }
};
